class AuthStore {
    private token: string | null = null;
  
    setToken(token: string): void {
      this.token = token;
    }
  
    getToken(): string | null {
      return this.token;
    }
  
    getAuthHeader(): Record<string, string> {
      if (!this.token) return {};
      return { 'x-auth-token': this.token };
    }
  
    clear(): void {
      this.token = null;
    }
  }
  
  export const authStore = new AuthStore();